import { AlertMessage } from '@/app/components'
import LoadingAnimation from '@/components/LoadingAnimation/LoadingAnimation'
import DeviceSuggestionCard from '@/app/pages/utility-program/unenroll/suggestions/components/DeviceSuggestionCard'
import ConfigureDeviceStepBody from '../components/ConfigureDeviceStepBody'
import ProgramPrescribedAlert from '../components/ProgramPrescribedAlert'
import useConfigureVehicleViewModel from './ConfigureVehicle.viewmodel'

const { SettingsSuggestions, SuggestionCard, SuggestionDescription } =
  DeviceSuggestionCard

export function ConfigureVehicle() {
  const {
    isLoadingOrIdle,
    displayName,
    limitsText,
    goalsValueText,
    scheduleDescriptions,
    tripsValueText,
    goalsArePrescribed,
    prescribedGoalLabels,
    settingPaths,
  } = useConfigureVehicleViewModel()

  if (isLoadingOrIdle) {
    return (
      <div className="flex justify-center items-center h-full">
        <LoadingAnimation type="falling" />
      </div>
    )
  }

  return (
    <ConfigureDeviceStepBody
      alertSlot={
        <AlertMessage variant="info">
          Set your daily Ready By time so we can optimize your charging based on
          when you plan to leave.
        </AlertMessage>
      }
    >
      <DeviceSuggestionCard
        iconName="PlainVehicle"
        title={displayName}
        articles={[]}
      >
        <SettingsSuggestions>
          <SuggestionCard
            iconName="BatteryCharging"
            title="Limits"
            destinationPath={settingPaths.limits}
          >
            <SuggestionDescription>
              Use this to adjust your car's charge limit
            </SuggestionDescription>
            <SuggestionDescription>{limitsText}</SuggestionDescription>
          </SuggestionCard>

          {goalsArePrescribed && (
            <>
              <SuggestionCard
                iconName="Target"
                title="Goals"
                destinationPath={settingPaths.goals}
              >
                <SuggestionDescription>
                  Set charging goals with Optiwatt. Tell us what matters most to
                  you
                </SuggestionDescription>
                <SuggestionDescription>{goalsValueText}</SuggestionDescription>
              </SuggestionCard>
              {prescribedGoalLabels.map((label) => (
                <ProgramPrescribedAlert
                  key={label}
                  settingDisplayName={label}
                />
              ))}
            </>
          )}

          <SuggestionCard
            iconName="Clock"
            title="Scheduling"
            destinationPath={settingPaths.scheduling}
          >
            <SuggestionDescription>
              Customize your ready by and start charge times for each day of the
              week
            </SuggestionDescription>
            <div className="flex flex-col">
              {scheduleDescriptions.length === 0 ? (
                <SuggestionDescription>
                  No scheduled departure/charging planned
                </SuggestionDescription>
              ) : (
                scheduleDescriptions.map((description) => (
                  <SuggestionDescription key={description}>
                    {description}
                  </SuggestionDescription>
                ))
              )}
            </div>
          </SuggestionCard>

          <SuggestionCard
            iconName="MapPin"
            title="Trips"
            destinationPath={settingPaths.trips}
          >
            <SuggestionDescription>
              Add charging preferences for any upcoming trips
            </SuggestionDescription>
            <SuggestionDescription>{tripsValueText}</SuggestionDescription>
          </SuggestionCard>
        </SettingsSuggestions>
      </DeviceSuggestionCard>
    </ConfigureDeviceStepBody>
  )
}
